












































import { Component, Vue } from "vue-property-decorator";
import { inverterService } from "@/services";
@Component({
  name: "app-addinverter",
  filters: {
    date: (value: string) => {
      if (value) {
        return (value = new Date(value).toDateString());
      }
    },
    caps: (value: string) => {
      if (value) {
        return value.toUpperCase();
      }
    },
    small: (value: any) => {
      return value.toLowerCase();
    },
  },
})
export default class AddInverter extends Vue {
  public res: any = [];
  public inverterCompany: any = [];
  isLoading = true;

  mounted() {
    this.getInverterCompany();
  }
  getInverterCompany() {
    inverterService.getInverterCompany().then((x: any) => {
      this.res = x.data.inverter_list;
      // console.log("Res1" + JSON.stringify(this.res));
    });
  }
}
